import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 阅读列表接口
export function getReadList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/magazines',
        method: 'get',
        params: {
            year: params.year,
            month: params.month,
            type: params.type
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 获取年份
export function getYearList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/magazines/years',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}


// 免费单行本列表
export function getFreeList(params) {
    var sign = getRequest(params);
    return request({
        url: `v4/themes/${params.id}/articles`,
        method: 'get',
        params: {
            id: params.id,
            page: params.page,
            per: params.per
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 收费单行本列表
export function getSubjectsList(params) {
    var sign = getRequest(params);
    return request({
        url: `/v4/subjects/${params.id}`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 收费单行本专栏文章列表
export function getChargeList(params) {
    var sign = getRequest({});
    return request({
        url: `/v4/subjects/${params.id}/articles`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 免费单行本专栏详情
export function getFreeDetailList(id) {
    var sign = getRequest(id);
    return request({
        url: 'v4/themes/get_theme',
        method: 'get',
        params: {
            id: id
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 杂志目录详情
export function getMagazinesList(id) {
    var sign = getRequest("");
    return request({
        url: `v4/magazines/${id}/articles`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}

// 右侧杂志详情
export function getMagazines(id) {
    var sign = getRequest("");
    return request({
        url: `v4/magazines/${id}`,
        method: 'get',
        params: {
            id: id
        },
        headers: {
            'X-Signature': sign
        }
    })
}

// 单行本-试读文章列表
export function getTryReadList(params) {
    var sign = getRequest(params);
    return request({
        url: `/v4/subjects/${params.id}/probation`,
        method: 'get',
        params: {
            page: params.page,
            per: params.per
        },
        headers: {
            'X-Signature': sign
        }
    })
}

// 单行本产品信息
export function getProduct(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/subject_orders/get_products',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}


// 购买
export function getSubjectOrder(data) {
    var sign = getRequest(data)
    return request({
        url: '/v4/subject_orders/pingpp_charge',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}

// 获取支付状态
export function getNotifyJs(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/subject_orders/${id}`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/read.js